import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
})
export class AuthCallbackComponent implements OnInit {

  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
  ) {}

  ngOnInit(): void {
    const code  = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const error = this.route.snapshot.queryParamMap.get('error');

    const isPopup = !!(window.opener && window.opener !== window);

    if (isPopup) {
      // Running inside a popup: relay code+state to the parent window and close.
      // The parent handles the token exchange so it retains the PKCE verifier.
      const errMsg = error || (!code || !state ? 'missing_params' : null);
      window.opener.postMessage(
        { type: 'AUTH0_CODE', code, state, error: errMsg },
        window.location.origin
      );
      window.close();
      return;
    }

    // Direct navigation (fallback redirect flow or external link)
    if (error || !code || !state) {
      this.error = error || 'missing_params';
      this.router.navigate(['/login'], { queryParams: { error: this.error } });
      return;
    }

    this.loginService.handleAuth0Callback(code, state).subscribe({
      next: () => this.router.navigate(['/']),
      error: err => {
        this.error = err?.message || 'auth_failed';
        this.router.navigate(['/login'], { queryParams: { error: this.error } });
      },
    });
  }
}
